<template>
<div class="noprint">
    <b-card v-if="!activatePayment && isLoaded && (currentPrice === 0 && clientType !== 'plugin')" no-body border-variant="msstream">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
            <h5 class="m-0"><font-awesome-icon icon="shopping-cart"></font-awesome-icon>&nbsp;&nbsp;{{$ml.get('producttitle')}}</h5>
        </b-card-header>
        <b-card-body>
            <b-row class="align-items-center">
                <b-col md="6" sm="6" cols="12">
                    <b-row class="justify-content-center marginaltop">
                        <b-col cols="auto">
                            <h6>
                                {{$ml.get('freetier')}}
                            </h6>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6" sm="6" cols="12">
                    <b-row class="align-item-center">
                        <b-col style="text-align: center;">
                            <b-button size="lg" variant="green" @click="getFullFeatures()">{{$ml.get('upgrade')}}</b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>

    <b-card v-if="!activatePayment && isLoaded && (currentPrice > 0 || clientType === 'plugin')"  no-body border-variant="msstream">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
            <h5 class="m-0"><font-awesome-icon icon="shopping-cart"></font-awesome-icon>&nbsp;&nbsp;{{$ml.get('producttitle')}}</h5>
        </b-card-header>
        <b-card-body>
            <!-- MB Month -->
            <b-row class="align-items-center">
                <b-col md="8" sm="8" cols="12">
                    <!-- VIEWING TIME -->
                    <b-row  v-if="typeOfContract === 'views'" class="justify-content-center marginaltop">
                        <b-col cols="auto">
                            <h5>
                                {{$ml.get('viewingt')}} <strong v-bind:class="{'text-red': currentViewingTime > maxViewingTime, 'text-blue': currentViewingTime <= maxViewingTime}">{{currentViewingTime}} / </strong> 
                                <strong v-bind:class="{'text-green': maxViewingTime > baseViewingTime, 'text-blue': maxViewingTime <= baseViewingTime}">{{maxViewingTime}} H</strong>
                                &nbsp;
                                <b-button v-if="!isAutoAdjust" variant="msstreamblue" @click="increaseViewingTime">+</b-button> 
                                &nbsp;
                                <b-button v-if="!isAutoAdjust && maxViewingTime > baseViewingTime && maxViewingTime > multiplierViewingTime" variant="quanteec" @click="decreaseAll">-</b-button>
                            </h5>
                        </b-col>
                    </b-row>
                    <b-row v-if="typeOfContract === 'views'" class="justify-content-center">
                        <b-col cols="4">
                            <h6 style="text-align:center;">
                                {{$ml.get('viewsp')}} <strong class="text-blue">{{totalViews}}</strong>
                            </h6>
                        </b-col>
                        <b-col cols="4">
                            <h6 style="text-align:center;">
                                {{$ml.get('meanvtp')}} <strong class="text-blue">{{meanViewingTime}}</strong>
                            </h6>
                        </b-col>
                    </b-row>
                    <b-row v-if="typeOfContract === 'views'" class="justify-content-center">
                        <b-col class="col-9">
                        <b-progress :max="maxViewingTime" height="2rem">
                            <b-progress-bar :value="currentViewingTime" animated :variant="(currentViewingTime > maxViewingTime) ? 'quanteecdanger':'quanteec'">
                                <!--Progress: <strong>{{ Math.round(dataMonth / 10000) / 100}} / {{ 10 }} TB</strong>-->
                            </b-progress-bar>
                        </b-progress>
                        </b-col>
                    </b-row>

                    <!-- DATA -->
                    <b-row  v-if="typeOfContract !== 'views'" class="justify-content-center marginaltop">
                        <b-col cols="auto">
                            <h4>
                                {{$ml.get('datadelivered')}} <strong v-bind:class="{'text-red': currentData > maxData, 'text-blue': currentData <= maxData}">{{currentData}} / </strong> 
                                <strong v-bind:class="{'text-green': maxData > baseData, 'text-blue': maxData <= baseData}">{{maxData}} {{$ml.get("GBunit")}}</strong>
                                &nbsp;
                                <b-button v-if="!isAutoAdjust" variant="msstreamblue" @click="increaseData">+</b-button> 
                                &nbsp;
                                <b-button v-if="!isAutoAdjust && maxData > baseData && maxData > multiplierData" variant="quanteec" @click="decreaseAll">-</b-button>
                            </h4>
                        </b-col>
                    </b-row>
                    
                    <b-row v-if="typeOfContract !== 'views'" class="justify-content-center">
                        <b-col class="col-9">
                        <b-progress :max="maxData" height="2rem">
                            <b-progress-bar :value="currentData" animated :variant="(currentData > maxData) ? 'quanteecdanger':'quanteec'">
                                <!--Progress: <strong>{{ Math.round(dataMonth / 10000) / 100}} / {{ 10 }} TB</strong>-->
                            </b-progress-bar>
                        </b-progress>
                        </b-col>
                    </b-row>
                    <b-row  v-if="typeOfContract !== 'views'" class="justify-content-center marginaltopsm">
                        <b-col cols="auto">
                            <small>+ <strong class="text-blue">{{priceData}} €</strong> {{$ml.get('peradditional')}} <strong class="text-blue">{{multiplierData}} {{$ml.get("GBunit")}}</strong>.</small>
                        </b-col>
                    </b-row>
                    <hr>
                    <!-- STORAGE -->
                    <div v-if="clientType !== 'plugin'">
                        <b-row class="justify-content-center marginaltop">
                            <b-col cols="auto">
                                <h5>
                                    {{$ml.get('storage')}} <strong v-bind:class="{'text-red': currentStorage > maxStorage, 'text-blue': currentStorage <= maxStorage}">{{currentStorage}} / </strong>
                                    <strong v-bind:class="{'text-green': maxStorage > baseStorage, 'text-blue': maxStorage <= baseStorage}">{{maxStorage}} {{$ml.get("GBunit")}}</strong>
                                    &nbsp;
                                    <b-button  v-if="!isAutoAdjust" variant="msstreamblue" @click="increaseStorage">+</b-button>
                                    &nbsp;
                                    <b-button v-if="!isAutoAdjust && maxStorage > baseStorage && maxStorage > multiplierStorage" variant="quanteec" @click="decreaseAll">-</b-button>
                                </h5>
                            </b-col>

                        </b-row>
                    
                        <b-row  class="justify-content-center">
                            <b-col class="col-9">
                            <b-progress :max="maxStorage" height="2rem">
                                <b-progress-bar :value="currentStorage" animated :variant="(currentStorage > maxStorage) ? 'quanteecdanger':'quanteec'">
                                    <!--Progress: <strong>{{ Math.round(dataMonth / 10000) / 100}} / {{ 10 }} TB</strong>-->
                                </b-progress-bar>
                            </b-progress>
                            </b-col>
                        </b-row>
                        <b-row  v-if="typeOfContract !== 'views'" class="justify-content-center marginaltopsm">
                            <b-col cols="auto">
                                <small>+ <strong class="text-blue">{{priceStorage}} €</strong> {{$ml.get('peradditional')}} <strong class="text-blue">{{multiplierStorage}} {{$ml.get("GBunit")}}</strong>.</small>
                            </b-col>
                        </b-row>
                        <hr>
                    </div>
                    <!-- ENCODINGS -->
                    <b-row class="justify-content-center marginaltop" v-if="clientType !== 'plugin'">
                        <b-col cols="auto">
                            <h5>{{$ml.get('concurrentencodings')}} 
                                <strong v-bind:class="{'text-green': maxEncoding > baseEncoding, 'text-blue': maxEncoding <= baseEncoding}">{{maxEncoding}}</strong> 
                                &nbsp;
                                <b-button  v-if="!isAutoAdjust" variant="msstreamblue" @click="increaseEncoding">+</b-button> 
                                &nbsp;
                                <b-button v-if="!isAutoAdjust && maxEncoding > baseEncoding && maxEncoding > multiplierEncoding" variant="quanteec" @click="decreaseAll">-</b-button>
                            </h5>
                        </b-col>
                    </b-row>
                    <b-row  v-if="typeOfContract !== 'views'" class="justify-content-center">
                        <b-col cols="auto">
                            <small>+ <strong class="text-blue">{{priceEncoding}} €</strong> {{$ml.get('peradditional')}} <strong class="text-blue">{{multiplierEncoding}}</strong>.</small>
                        </b-col>
                    </b-row>

                </b-col>
                <b-col v-if="!isAutoAdjust" md="3" sm="3" cols="12">
                    <b-row class="align-item-center">
                        <b-col style="text-align: center;">
                            <h4>{{$ml.get('basep')}} <span><strong class="text-blue">{{basePrice}} € </strong><small> / {{$ml.get('month')}}</small></span></h4>
                        </b-col>
                    </b-row>
                    <b-row class="align-item-center marginal">
                        <b-col style="text-align: center;">
                            <h5 v-if="!isAutoAdjust && (maxViewingTime > baseViewingTime || maxStorage > baseStorage || maxEncoding > baseEncoding)">
                                New price: <strong class="text-green">{{newPrice_computed}} € </strong><small> / {{$ml.get('month')}}</small>
                                &nbsp;
                            </h5>
                           
                        </b-col>
                    </b-row>
                    <b-row  v-if="!isAutoAdjust && (maxViewingTime > baseViewingTime || maxStorage > baseStorage || maxEncoding > baseEncoding)" class="justify-content-center">
                        <b-col style="text-align-center" cols="auto">
                            <b-button variant="green" @click="showModal('confirmValidate')">Validate</b-button>
                        </b-col>
                    </b-row>
                    <b-row  v-if="!isAutoAdjust && (maxViewingTime === baseViewingTime && maxStorage === baseStorage && maxEncoding === baseEncoding)" class="justify-content-center">
                        <b-col style="text-align-center" cols="auto">
                            <b-button variant="green" @click="activatePayment = true">Modify payment method</b-button>
                        </b-col>
                    </b-row>
                    <!--<b-row v-if="forLater" class="align-item-center marginal">
                        <b-col style="text-align: center;">
                            <b-button @click="showModal('confirmAutoAdjust')">Auto adjust capacities</b-button>
                        </b-col>
                    </b-row>
                    <b-row v-if="forLater" class="align-item-center marginal">
                        <b-col style="text-align: center;">
                        <h6>Capacities and price auto adjusted</h6>
                        </b-col>
                    </b-row>-->
                </b-col>

                 <b-col v-if="isAutoAdjust && isContractSigned" md="3" sm="3" cols="12">
                    <b-row class="align-item-center">
                        <b-col style="text-align: center;">
                            <h3>{{$ml.get('pricethismonth')}} <span><strong class="text-green">{{newPrice_computed}} € </strong><small> / {{$ml.get('month')}}</small></span></h3>
                        </b-col>
                    </b-row>
                    <b-row class="align-item-center marginal">
                        <b-col style="text-align: center;">
                            <h5>
                                {{$ml.get('baseprice')}} <strong class="text-blue">{{basePrice}} € </strong><small> / {{$ml.get('month')}}</small>
                                &nbsp;
                            </h5>
                           
                        </b-col>
                    </b-row>
                    <b-row v-if="isRIB" class="align-item-center marginal">
                        <b-col style="text-align: center;">
                            <small>
                                {{$ml.get('modifybankdetails')}} <a href="mailto:contact@quanteec.com">contact@quanteec.com</a>
                            </small> 
                        </b-col>
                    </b-row>
                    <b-form v-if="!isRIB" @submit.prevent="postRIB()">
                        <b-form-group
                            label="RIB:"
                        >
                            <b-form-file v-model="file" :state="Boolean(file)" required :placeholder="$ml.get('chooseRIB')"></b-form-file>
                        </b-form-group>
                        <b-row class="justify-content-center">
                            <b-col md="auto">
                                <b-button variant="msstreamblue" type="submit">{{$ml.get('uploadbankdet')}}</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-col>

                 <b-col v-if="isAutoAdjust && !isContractSigned" md="3" sm="3" cols="12">
                    <b-row class="align-item-center">
                        <b-col style="text-align: center;">
                            <h3>{{$ml.get('baseprice')}} <span><strong class="text-green">{{basePrice}} € </strong><small> / {{$ml.get('month')}}</small></span></h3>
                        </b-col>
                    </b-row>

                    <b-form @submit.prevent="validateContract()" class="marginaltop">
                        <a :href="($ml.current === 'FR') ? 'https://quanteec.com/cgu/CGUV_Quanteec_FR.pdf': 'https://quanteec.com/cgu/QUANTEEC_T+C_EN.pdf'" target="_blank">
                            <b-row class="justify-content-center align-items-center">
                                <b-col cols="3" style="padding-left: 0px; padding-right: 0px;">
                                    <b-img
                                    :src="require('@/assets/pdf.png')"
                                    fluid
                                    ></b-img>
                                </b-col>
                                <b-col cols="auto" style="padding-left: 0px; padding-right: 0px;">
                                    {{$ml.get('termsofservice')}}
                                </b-col>
                                
                            </b-row>
                        </a>
                        <b-form-group>
                        <b-form-checkbox
                        style="line-height: 1.5 !important;"
                            id="checkbox-1"
                            v-model="cguAccepted"
                            name="checkbox-cgu"
                            required
                            >
                            {{$ml.get('accepttermsofservice')}}
                            </b-form-checkbox>
                        </b-form-group>
                        <b-row class="justify-content-center">
                            <b-col cols="auto">
                                <b-button type="submit" variant="green" :disabled="!cguAccepted">{{$ml.get('acceptcontract')}}</b-button>
                            </b-col>
                        </b-row>
                    </b-form>

                </b-col>
            </b-row>
        </b-card-body>
    </b-card>

    <b-card v-if="activatePayment" no-body border-variant="msstream">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
            <h5 class="m-0"><font-awesome-icon icon="shopping-cart"></font-awesome-icon>&nbsp;PAYMENT METHOD</h5>
        </b-card-header>
        <b-card-body>
            <Payment :value="paymentValue"></Payment>
        </b-card-body>
    </b-card>

    <b-modal ref="confirmValidate" hide-footer hide-header>
      <div class="d-block text-center">
        <h4>Validate the new price: {{newPrice_computed}} €/{{$ml.get('month')}}</h4>
      </div>
      <p>This operation will definitely modify your offer.</p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="green" block @click="validatePrice();hideModal('confirmValidate')">Yes, validate</b-btn>
          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="hideModal('confirmValidate')">Cancel</b-btn>
      </b-row>
    </b-modal>
    <b-modal ref="confirmAutoAdjust" hide-footer hide-header>
      <div class="d-block text-center">
        <h4>Auto adjust the price according to the capacities used</h4>
      </div>
      <p>The price at the end of the month may vary according to the ressources used.</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="green" block @click="setAutoAdjust();hideModal('confirmAutoAdjust')">Yes, validate</b-btn>

          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="hideModal('confirmAutoAdjust')">Cancel</b-btn>

      </b-row>
    </b-modal>

    <b-modal ref="ContractAccepted" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('contractaccepted')}}</h3>
      </div>
      <p>{{$ml.get('welcomeRIB')}} <a href="mailto:contact@quanteec.com">contact@quanteec.com</a></p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="green" block @click="hideModal('ContractAccepted')">Ok</b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="ErrorContract" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('Error')}}</h3>
      </div>
      <p>{{$ml.get('errorcontract')}} <a href="mailto:contact@quanteec.com">contact@quanteec.com</a></p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('ErrorContract')">Ok</b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="RIBSuccess" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('bankreceived')}}</h3>
      </div>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('RIBSuccess')">Ok</b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="RIBError" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('Error')}}</h3>
      </div>
      <p>{{$ml.get('errorcontract')}} <a href="mailto:contact@quanteec.com">contact@quanteec.com</a></p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('RIBError')">Ok</b-btn>
      </b-row>
    </b-modal>
</div>
</template>

<script>
import Payment from '@/components/Payment';
import UserService from "@/services/user.service";
import ClientService from "@/services/client.service";
import DocumentService from "@/services/document.service";
import PaymentService from '@/services/payment.service';
let paymentService = new PaymentService();
import AnalyticsService from "@/services/analytics.service";
var analyticsService = new AnalyticsService();

var userService = new UserService();
var clientService = new ClientService();
var documentService = new DocumentService();
var myDateBegin = new Date();
export default {
  name: 'PriceAnalytics',
  data: function() {
      return {
          clientView: (this.$auth.getMyUser().roles.indexOf('admin') > -1) ? this.$auth.getMyClientView() || this.$auth.getMyUser().client : this.$auth.getMyUser().client,
            key: '',
            dateEnd: new Date(),
            dateBegin: new Date(myDateBegin.getFullYear(), myDateBegin.getMonth(), 1, 0, 0, 0),
            interval: '1d',
            filter: '*',
            totalViewingTime: 0,
            totalViews: 0,

            currentPrice: 0,
            multiplierPrice: 200,
            partialMultiplierPrice: 100,
            basePrice: 0,

            currentData: 0,
            multiplierData: 1000,
            baseData: 0,
            maxData: 0,
            priceData: 20,

            currentViewingTime: 0,
            multiplierViewingTime: 1000,
            baseViewingTime: 0,
            maxViewingTime: 0,
            priceViewingTime: 0,

            currentStorage: 0,
            multiplierStorage: 3000,
            baseStorage: 0,
            maxStorage: 0,
            priceStorage: 100,

            currentEncoding: 0,
            multiplierEncoding: 10,
            baseEncoding: 0,
            maxEncoding: 0,
            priceEncoding: 100,

            isAutoAdjust: true,
            paymentValue: 0,
            activatePayment: false,

            clientType: 'plugin',
            isLoaded : false,
            forLater: false,

            isRIB : false,
            isContractReady: false,
            isContractSigned: false,
            typeOfContract: "views",
            cguAccepted: false,
            file: null
      }
  },
  components: {
      Payment
  },
  mounted() {
      this.key = this.clientView;
      this.getDataMonth();
      this.loadNewClientUuid();
      this.loadViewingTime();
      this.loadData();

  },
  computed: {
      dataMonth_computed() {
          return (Math.round(this.dataMonth / 10000) / 100) + ' TB';
      },
      newPrice_computed() {
          let price = this.computeNewPrice();

          return price; 
      },
      meanViewingTime() {
          if (this.totalViews > 0) {
            let value = Math.round(this.totalViewingTime / this.totalViews)
            let result = '';
            result += value + ' s'
            return result;
          } else {
            return '0 s';
          }
      },
  },
  methods: {
      getFullFeatures() {
        this.maxStorage = this.multiplierStorage;
        this.maxViewingTime = this.multiplierViewingTime;
        this.maxEncoding = this.multiplierEncoding;

        /*if (this.clientType === "plugin") {
            this.basePrice = this.partialMultiplierPrice;
        } else {
            this.basePrice = this.multiplierPrice;
        }*/

        this.currentPrice = this.computeNewPrice();

      },
      getDataMonth() {
          userService.getStorage(this.$auth.token()).then((diskSpace) => {
              let storage =  Math.round((diskSpace.size - diskSpace.free) / 1000000000);
              this.currentStorage = storage;
          }).catch((err) => {
              console.error(err);
          })

          if ((this.$auth.getMyUser().roles.indexOf('admin') > -1)) {
            userService.getClient(this.$auth.token(), this.clientView).then((client) => {
                  this.isContractReady = (client.isContractReady !== undefined) ? client.isContractReady : false;
                  this.isContractSigned = (client.isContractSigned !== undefined) ? client.isContractSigned : false;
                  this.isRIB = (client.isRIB !== undefined) ? client.isRIB : false;
                  this.typeOfContract = (client.typeOfContract !== undefined) ? client.typeOfContract : "views";

                  this.maxData = (client.maxData !== undefined) ? client.maxData : this.baseData;
                  this.maxStorage = (client.maxStorage !== undefined) ? client.maxStorage : this.baseStorage;
                  this.maxViewingTime = (client.maxViewingTime !== undefined) ?  client.maxViewingTime : this.baseViewingTime;
                  this.maxEncoding = (client.maxEncoding !== undefined) ?  client.maxEncoding : this.baseEncoding;

                  this.multiplierData = (client.multiplierData !== undefined) ? client.multiplierData : this.multiplierData;
                  this.multiplierStorage = (client.multiplierStorage !== undefined) ? client.multiplierStorage : this.multiplierStorage;
                  this.multiplierViewingTime = (client.multiplierViewingTime !== undefined) ?  client.multiplierViewingTime : this.multiplierViewingTime;
                  this.multiplierEncoding = (client.multiplierEncoding !== undefined) ?  client.multiplierEncoding : this.multiplierEncoding;

                  this.priceData = (client.priceData !== undefined) ? client.priceData : this.priceData;
                  this.priceStorage = (client.priceStorage !== undefined) ? client.priceStorage : this.priceStorage;
                  this.priceViewingTime = (client.priceViewingTime !== undefined) ?  client.priceViewingTime : this.priceViewingTime;
                  this.priceEncoding = (client.priceEncoding !== undefined) ?  client.priceEncoding : this.priceEncoding;

                  this.baseData = (client.baseData !== undefined) ? client.baseData : this.maxData;
                  this.baseViewingTime = (client.baseViewingTime !== undefined) ? client.baseViewingTime : this.maxViewingTime;
                  this.baseStorage = (client.baseStorage !== undefined) ? client.baseStorage : this.maxStorage;
                  this.baseEncoding = (client.baseEncoding !== undefined) ? client.baseEncoding : this.maxEncoding;

                  this.clientType = client.type;

                  this.basePrice = client.price || 0;

                  this.currentPrice = this.computeNewPrice();
                  this.isLoaded = true;               
              })
          } else {
              userService.getMyUser(this.$auth.token()).then((user) => {
                  this.isContractReady = (user.client_infos[0].isContractReady !== undefined) ? user.client_infos[0].isContractReady : false;
                  this.isContractSigned = (user.client_infos[0].isContractSigned !== undefined) ? user.client_infos[0].isContractSigned : false;
                  this.isRIB = (user.client_infos[0].isRIB !== undefined) ? user.client_infos[0].isRIB : false;
                  this.typeOfContract = (user.client_infos[0].typeOfContract !== undefined) ? user.client_infos[0].typeOfContract : "views";

                  this.maxData = (user.client_infos[0].maxData !== undefined) ? user.client_infos[0].maxData : this.baseData;
                  this.maxStorage = (user.client_infos[0].maxStorage !== undefined) ? user.client_infos[0].maxStorage : this.baseStorage;
                  this.maxViewingTime = (user.client_infos[0].maxViewingTime !== undefined) ?  user.client_infos[0].maxViewingTime : this.baseViewingTime;
                  this.maxEncoding = (user.client_infos[0].maxEncoding !== undefined) ?  user.client_infos[0].maxEncoding : this.baseEncoding;

                  this.multiplierData = (user.client_infos[0].multiplierData !== undefined) ? user.client_infos[0].multiplierData : this.multiplierData;
                  this.multiplierStorage = (user.client_infos[0].multiplierStorage !== undefined) ? user.client_infos[0].multiplierStorage : this.multiplierStorage;
                  this.multiplierViewingTime = (user.client_infos[0].multiplierViewingTime !== undefined) ?  user.client_infos[0].multiplierViewingTime : this.multiplierViewingTime;
                  this.multiplierEncoding = (user.client_infos[0].multiplierEncoding !== undefined) ?  user.client_infos[0].multiplierEncoding : this.multiplierEncoding;

                  this.priceData = (user.client_infos[0].priceData !== undefined) ? user.client_infos[0].priceData : this.priceData;
                  this.priceStorage = (user.client_infos[0].priceStorage !== undefined) ? user.client_infos[0].priceStorage : this.priceStorage;
                  this.priceViewingTime = (user.client_infos[0].priceViewingTime !== undefined) ?  user.client_infos[0].priceViewingTime : this.priceViewingTime;
                  this.priceEncoding = (user.client_infos[0].priceEncoding !== undefined) ?  user.client_infos[0].priceEncoding : this.priceEncoding;

                  this.baseData = (user.client_infos[0].baseData !== undefined) ? user.client_infos[0].baseData : this.maxData;
                  this.baseViewingTime = (user.client_infos[0].baseViewingTime !== undefined) ? user.client_infos[0].baseViewingTime : this.maxViewingTime;
                  this.baseStorage = (user.client_infos[0].baseStorage !== undefined) ? user.client_infos[0].baseStorage : this.maxStorage;
                  this.baseEncoding = (user.client_infos[0].baseEncoding !== undefined) ? user.client_infos[0].baseEncoding : this.maxEncoding;

                  this.clientType = user.client_infos[0].type;

                  this.basePrice = user.client_infos[0].price || 0;

                  this.currentPrice = this.computeNewPrice();
                  this.isLoaded = true;
              })
          }


      },
      setAutoAdjust() {
          this.isAutoAdjust = true;
          /*this.maxData = this.baseData;
          this.maxViewingTime = this.baseViewingTime;
          this.maxStorage = this.baseStorage;
          this.maxEncoding = this.baseEncoding;*/
          while (this.currentData > this.maxData) {
              this.maxData += this.multiplierData;
          }
          while (this.currentViewingTime > this.maxViewingTime) {
              this.maxViewingTime += this.multiplierViewingTime;
          }
          while (this.currentStorage > this.maxStorage) {
              this.maxStorage += this.multiplierStorage;
          }
          while (this.currentEncoding > this.maxEncoding) {
              this.maxEncoding += this.multiplierEncoding;
          }
      },
      increaseViewingTime() {
          this.maxViewingTime = this.maxViewingTime + this.multiplierViewingTime;
      },
      increaseData() {
          this.maxData = this.maxData + this.multiplierData;
      },
      decreaseViewingTime() {
        if (this.maxViewingTime > this.baseViewingTime && this.maxViewingTime > this.multiplierViewingTime)
            this.maxViewingTime = this.maxViewingTime - this.multiplierViewingTime;
      },
      increaseStorage() {
          this.maxStorage = this.maxStorage + this.multiplierStorage;
      },
      decreaseStorage() {
        if (this.maxStorage > this.baseStorage && this.maxStorage > this.multiplierStorage)
            this.maxStorage = this.maxStorage - this.multiplierStorage;
      },
      increaseEncoding() {
        this.maxEncoding = this.maxEncoding + this.multiplierEncoding;
      },
      decreaseEncoding() {
        if (this.maxEncoding > this.baseEncoding && this.maxEncoding> this.multiplierEncoding)
            this.maxEncoding = this.maxEncoding - this.multiplierEncoding;
      },
      decreaseAll() {
          this.decreaseViewingTime();
          this.decreaseEncoding();
          this.decreaseStorage();
      },
      computeNewPrice() {
          if (this.clientType !== 'plugin') {
            if (this.typeOfContract === 'views') {
                let bonusData = Math.floor(this.maxData / this.multiplierData);
                let bonusViewingTime = Math.floor(this.maxViewingTime / this.multiplierViewingTime);
                let bonusStorage = Math.floor(this.maxStorage / this.multiplierStorage);
                let bonusEncoding = Math.floor(this.maxEncoding / this.multiplierEncoding);

                let maxBonus = Math.max(bonusViewingTime, bonusStorage, bonusEncoding);
                let partialBonus = 0;

                while (bonusViewingTime < maxBonus - 1) {
                    this.maxViewingTime += this.multiplierViewingTime;
                    bonusViewingTime = Math.floor(this.maxViewingTime / this.multiplierViewingTime);
                }

                while (bonusStorage < maxBonus - 1) {
                    this.maxStorage += this.multiplierStorage;
                    bonusStorage = Math.floor(this.maxStorage / this.multiplierStorage);
                }

                while (bonusEncoding < maxBonus - 1) {
                    this.maxEncoding += this.multiplierEncoding;
                    bonusEncoding = Math.floor(this.maxEncoding / this.multiplierEncoding) ;
                }

                let minBonus = Math.min(bonusViewingTime, bonusStorage, bonusEncoding);
            
                let sumBonus = bonusViewingTime + bonusStorage + bonusEncoding;

                // Si un seul est plus grand que les autres, on n'augment que de la moitié
                if (sumBonus === 3 * minBonus + 1) {
                    if (maxBonus > 0) {
                        maxBonus--;
                        partialBonus++;
                    } 
                } else if (sumBonus === 3 * minBonus + 2) { // Si deux sont plus grand que le troisième, on monte aussi le troisième
                    if (minBonus === bonusViewingTime) {
                        this.maxViewingTime += this.multiplierViewingTime;
                    }
                    if (minBonus === bonusStorage) {
                        this.maxStorage += this.multiplierStorage;
                    }
                    if (minBonus === bonusEncoding) {
                        this.maxEncoding += this.multiplierEncoding;
                    }
                }
                if (maxBonus < 0) maxBonus = 0;
                if (partialBonus < 0) partialBonus = 0;


                return this.multiplierPrice * maxBonus + this.partialMultiplierPrice * partialBonus;
            }
            if (this.typeOfContract === 'data') {
                let bonusData = Math.floor((this.maxData - this.baseData) / this.multiplierData);
                let bonusStorage = Math.floor((this.maxStorage - this.baseStorage) / this.multiplierStorage);
                let bonusEncoding = Math.floor((this.maxEncoding - this.baseEncoding) / this.multiplierEncoding);
                return this.basePrice + bonusData * this.priceData + bonusStorage * this.priceStorage + bonusEncoding * this.priceEncoding;
            }
          } else {
            let bonusViewingTime = Math.floor(this.maxViewingTime / this.multiplierViewingTime);
            if (bonusViewingTime < 0) {
                bonusViewingTime = 0;
            }
            return this.partialMultiplierPrice * bonusViewingTime;
          }
      },
      validatePrice() {
          paymentService.postComputePrice({maxViewingTime: this.maxViewingTime, maxStorage: this.maxStorage, maxEncoding: this.maxEncoding}, this.$auth.token())
          .then((result) => {
            paymentService.getPaymentNeeded(this.$auth.token()).then((result) => {
                if (result.paymentNeeded) {
                    this.activatePayment = true;
                } else {
                    paymentService.postPaymentProduct(this.$auth.token()).then(() => {
                        this.baseViewingTime = this.maxViewingTime;
                        this.baseStorage = this.maxStorage;
                        this.baseEncoding = this.maxEncoding;
                        this.currentPrice = this.computeNewPrice();
                        this.basePrice = this.currentPrice;
                    }).catch(err => {

                    });
                }
                   
            }).catch(err => {

            })
            
          }).catch(err => {
              
          });
      },

      //Show modal if wrong date 
      showModal(ref) {
        this.$refs[ref].show();
      },
      hideModal(ref) {
        this.$refs[ref].hide();
      },
      loadNewClientUuid() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'new_client_uuid.keyword', type: 'cardinality'}];
            let options = {dateBegin: self.dateBegin, dateEnd: self.dateEnd, interval: self.interval, filter: self.filter};
            let data = self.templateRequest(options, values);
            self.loadRequest(data, values).then(() => {
                self.totalViews = self.new_client_uuid.reduce((a,b)=> {return {y: Math.round(a.y + b .y)}}).y;
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadViewingTime() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'sec_peer', type: 'sum'}, {name: 'sec_server', type: 'sum'}];
            let options = {dateBegin: self.dateBegin, dateEnd: self.dateEnd, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values);
            self.loadRequest(data, values).then(() => {
                let totalsec_peer = self.sec_peer.reduce((a,b)=> {return {y: Math.round(a.y + b .y)}}).y;
                let totalsec_server = self.sec_server.reduce((a,b)=> {return {y: Math.round(a.y + b .y)}}).y;
                self.totalViewingTime = totalsec_peer + totalsec_server;
                self.currentViewingTime = Math.round(self.totalViewingTime / 3600);
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadData() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'MB_peer', type: 'sum'}, {name: 'MB_server', type: 'sum'}];
            let options = {dateBegin: self.dateBegin, dateEnd: self.dateEnd, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values);
            self.loadRequest(data, values).then(() => {
                let totalMB_peer = self.MB_peer.reduce((a,b)=> {return {y: Math.round(a.y + b .y)}}).y;
                let totalMB_server = self.MB_server.reduce((a,b)=> {return {y: Math.round(a.y + b .y)}}).y;
                self.totalData = totalMB_peer + totalMB_server;
                self.currentData = Math.round(self.totalData / 1000000);
                self.setAutoAdjust();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadRequest(data, valuesToFill) {
        let self = this;
        return new Promise ((done, reject) => {
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    for(let j = 0; j < valuesToFill.length; j++) {
                        let myValue = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].name.split('.')[0] : valuesToFill[j].name;
                        self[myValue] = [];
                    }
                    for(let i = 0; i < buckets.length; i++) {
                        for(let j = 0; j < valuesToFill.length; j++) {
                            let myValue = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].name.split('.')[0] : valuesToFill[j].name;
                            self[myValue].push({
                                x: new Date(buckets[i].key),
                                y: buckets[i][myValue].value
                            });
                        }
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    templateRequest({dateBegin, dateEnd, interval, filter}, values) {
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBegin.getTime().toString(),
                                    "lte": dateEnd.getTime().toString(),
                                    "format":"epoch_millis"
                                }
                            }
                        },
                        {
                            "query_string":{
                                "analyze_wildcard": true,
                                "query": filter
                            }
                        }
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBegin.getTime().toString(),
                            "max": dateEnd.getTime().toString()
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {

                    }
                }
            }
        }

        for (var i = 0; i < values.length; i++) {
            let name = (values[i].name.indexOf('keyword') > -1) ? values[i].name.split('.')[0] : values[i].name;
            let value = values[i].name;
            let type = values[i].type
            data.aggs.histogram.aggs[name] = {}
            data.aggs.histogram.aggs[name][type] = {
                "field": value,
                "missing":0
            }
        }

        return data;
    },
    validateContract() {
        this.isContractSigned = true;
        try {
            clientService.putClientContract(this.clientView, this.isContractSigned, this.$auth.token())
            .then(() => {
                this.showModal("ContractAccepted");
            }).catch(err => {
                this.isContractSigned = false;
                this.showModal("ErrorContract");
            })
        } catch(err) {
             this.isContractSigned = false;
            this.showModal("ErrorContract");
        };

    },
    postRIB() {
        let monthTable = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
        let formData = new FormData();
        formData.append('client', this.clientView);
        formData.append('type', "rib");
        formData.append('year', new Date().getFullYear());
        formData.append('month',  monthTable[new Date().getMonth()]);
        formData.append('file', this.file, "RIB_" + new Date().getTime() + '.pdf');

        documentService.postDocument(this.$auth.token(), formData).then(() => {
            this.file = null;
            this.isRIB = true;
            clientService.putClientRIB(this.clientView, this.isRIB, this.$auth.token()).then(() => {
                this.showModal("RIBSuccess");
            }).catch(err => {
                this.isRIB = false;
                this.showModal("RIBError");
            }) 
        }).catch(err => {
            this.showModal("RIBError");
        })
    }
  }
}
</script>

<style scoped>
@media print {
   .noprint {
       display: none;
    }
}
</style>